export const cn = (...classes: (string | null | undefined | false)[]): string =>
  classes.filter(Boolean).join(' ');
